import { radii, stackPartitions, slicePartitions } from '../mixinProps'
/**
 * vc-graphics-ellipsoid base props mixins
 */
export default {
  mixins: [radii, stackPartitions, slicePartitions]
}
